// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visx-tooltip {
  pointer-events: none;
}

.noDataContainer_ZwhHo.win_PZS8o {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes-graphs/lib/viewers/XYChartRenderer.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB","sourcesContent":[":global(.visx-tooltip) {\n  pointer-events: none;\n}\n\n.noDataContainer.win {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noDataContainer": `noDataContainer_ZwhHo`,
	"win": `win_PZS8o`
};
export default ___CSS_LOADER_EXPORT___;
